import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RememberMeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"remember_me"}/>
}
